import React from "react";
import { Modal } from "@UI/Components/Modal/Modal";
import { VStack, HStack } from "@UI/Components/Stack/Stack";
import { Heading } from "@UI/Components/Heading/Heading";
import { Text } from "@UI/Components/Text/Text";
import { Button } from "@UI/Components/Button/Button";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "@modules/ServiceProviders/Components/messages";

interface IDeleteCompanyModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

export const DeleteCompanyModal: React.FC<IDeleteCompanyModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={<Heading size="lg"><FormattedMessage {...messages.deleteBusinessAccount} /></Heading>}
    >
      <VStack spacing={4}>
        <Text>
          <FormattedMessage {...messages.confirmDeleteBusinessAccount} />
        </Text>
        <HStack spacing={4} width="100%">
          <Button width="full" onClick={onClose} variant="ghost">
            <FormattedMessage {...messages.cancel} />
          </Button>
          <Button width="full" colorScheme="red" onClick={onConfirm} isLoading={isLoading}>
            <FormattedMessage {...messages.confirm} />
          </Button>
        </HStack>
      </VStack>
    </Modal>
  );
};
